import React, { useState, useEffect, useMemo } from 'react';
import { MessageCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const WhatsAppButton = () => {
  const [settings, setSettings] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let mounted = true;
    
    const fetchSettings = async () => {
      try {
        const { data } = await axios.get(`${BACKEND_URL}/api/settings/global`);
        if (mounted) {
          setSettings(data);
          setIsVisible(data.enable_whatsapp);
        }
      } catch (error) {
        console.error('Failed to fetch WhatsApp settings');
      }
    };
    
    fetchSettings();
    
    return () => {
      mounted = false;
    };
  }, []);

  const handleClick = useMemo(() => {
    return () => {
      if (!settings?.whatsapp_number) return;
      const message = settings.whatsapp_message?.en || 'Hello, I am interested in renting an apartment.';
      const url = `https://wa.me/${settings.whatsapp_number}?text=${encodeURIComponent(message)}`;
      window.open(url, '_blank');
    };
  }, [settings]);

  if (!isVisible || !settings?.whatsapp_number) return null;

  return (
    <button
      data-testid="whatsapp-button"
      onClick={handleClick}
      className="fixed bottom-8 left-8 z-40 bg-primary hover:bg-primary/90 text-primary-foreground w-14 h-14 rounded-full flex items-center justify-center shadow-xl hover:shadow-2xl transition-shadow duration-200"
      aria-label="Contact via WhatsApp"
    >
      <MessageCircle size={24} />
    </button>
  );
};